import React, { useContext, useEffect, useState } from 'react'
import { Link } from 'react-router-dom'

import { userContext } from '../../../contextProvider/Authentication';
import { decrypt } from '../../../Functions/authentication';
import loginbg from "./../../../images/login-bg.jpg";
import ForgetPassword from './ForgetPassword';

function Login() {

	const { loginUser } = useContext(userContext);

	const [email, setEmail] = useState('');
	let errorsObj = { email: '', password: '' };
	const [errors, setErrors] = useState(errorsObj);
	const [password, setPassword] = useState('');
	const [passLength, setPassLength] = useState(false);
	const [newPass, setNewPass] = useState(false);
	const [showFP, setShowFP] = useState(false);
	const [logo, setLogo] = useState();

	useEffect(() => {
		let t = localStorage.getItem('tenant') && decrypt(localStorage.getItem('tenant'), 'lstenant');
		setLogo(t?.logo);
	}, []);

	function onLogin(e) {
		e.preventDefault();
		let error = false;
		const errorObj = { ...errorsObj };
		if (email === '') {
			errorObj.email = 'Username is Required';
			error = true;
		}
		if (password === '') {
			errorObj.password = 'Password is Required';
			error = true;
		}
		setErrors(errorObj);
		if (error) {
			return;
		}
		if (password.length < 6) {
			setPassLength(true);
		} else {
			setPassLength(false);
			loginUser(email, password)
		}
	}

	return (
		<>
			{
				showFP &&
				<ForgetPassword
					setShowFP={setShowFP}
				/>
			}
			<div className="page-wraper">
				<div className="page-content bg-white login-style2" style={{ backgroundImage: "url(" + loginbg + ")", backgroundSize: "cover" }}>
					<div className="section-full">
						<div className="container">
							<div className="row">
								<div className="col-lg-6 col-md-6 d-flex">
									<div className="text-white max-w400 align-self-center">
										<div className="logo">
											<Link to={"/"}><img src={logo} alt="" height="50px" width="50px" /></Link>
										</div>
										<h2 className="m-b10">Login To You Now</h2>
										<p className="m-b30">Lorem Ipsum is simply dummy text of the printing and typesetting industry has been the industry.</p>
										<ul className="list-inline m-a0">
											<li><Link to={''} className="m-r10 text-white "><i className="fa fa-facebook"></i></Link></li>
											<li><Link to={''} className="m-r10 text-white "><i className="fa fa-google-plus"></i></Link></li>
											<li><Link to={''} className="m-r10 text-white "><i className="fa fa-linkedin"></i></Link></li>
											<li><Link to={''} className="m-r10 text-white "><i className="fa fa-instagram"></i></Link></li>
											<li><Link to={''} className="m-r10 text-white"><i className="fa fa-twitter"></i></Link></li>
										</ul>
									</div>
								</div>
								<div className="col-lg-6 col-md-6">
									<div className="login-2 submit-resume p-a30 seth">
										<div className="nav">
											<form onSubmit={onLogin} className="col-12 p-a0 ">
												<p className="font-weight-600">If you have an account with us, please log in.</p>
												<div className="form-group ">
													<label>Username *</label>
													<div className="input-group">
														<input type="text" className="form-control"
															style={{ height: "40px" }}
															placeholder="Type Your Username"
															value={email}
															onChange={(e) => setEmail(e.target.value)}
															onKeyPress={(e) => {
																setErrors({ ...errorsObj });
																e.target.value.length >= 50 && e.preventDefault()
															}}
														/>
													</div>
													{errors.email && <div className="text-danger fs-12">{errors.email}</div>}
												</div>
												<div className="form-group">
													<label>Password *</label>
													<div className="input-group">
														<input
															style={{ height: "40px" }}
															type={newPass ? "text" : "password"}
															className="change-password form-control"
															value={password}
															placeholder="Type Your Password"
															onChange={(e) =>
																setPassword(e.target.value)
															}
															onKeyPress={(e) => {
																setErrors({ ...errorsObj });
																password.length < 6 && setPassLength(false);
																e.target.value.length >= 30 && e.preventDefault()
															}}
														/>
														<div className="change-password input-group-text" style={{ cursor: "pointer" }} onClick={() => setNewPass(!newPass)}>
															<i className="fa fa-eye" />
														</div>
													</div>
													{errors.password && <div className="text-danger fs-12">{errors.password}</div>}
													{passLength && <div className="text-danger fs-12">Password must be minimum 6 characters</div>}
												</div>
												<div className="text-center">
													<button className="site-button float-left">Login</button>
													<Link to="#" className="site-button-link forget-pass m-t5 float-right" onClick={() => setShowFP(true)}>
														<i className="fa fa fa-key" title='Reset Password' />Forget Password
													</Link>
													<Link to="/register" className="site-button-link mr-3 forget-pass m-t5 float-center">
														<i className="fa fa-unlock-alt mr-1" title='Sign up' ></i>
														Sign up
													</Link>

												</div>
											</form>
											{/* <Link to="#" className="site-button-link forget-pass m-t5 float-left mt-3" onClick={() => setShowFP(true)}>
												<i className="fa fa fa-key" title='Reset Password' style={{ fontSize: "25px" }}></i>
												Forget Password
											</Link> */}
										</div>
									</div>
								</div>
							</div>
						</div>

					</div>
					<footer className="login-footer">
						<div className="container">
							<div className="row">
								<div className="col-lg-12 text-center">
									<span className="float-left">© Copyright by <i className="fa fa-heart m-lr5 text-red heart"></i>
										<a href="https://www.boscosofttech.com/" target="blank">BoscoSoft</a> </span>
									<span className="float-right">
										All rights reserved.
									</span>
								</div>
							</div>
						</div>
					</footer>
				</div>
			</div>
		</>
	);
};


export default Login;
